import { withDisplayName } from '@hocs/with-display-name'
import { useTrackNavigationLink } from '@hooks/use-track-navigation-link'
import { ENHANCED_COMPONENT_TYPE } from '@ui/enhanced-components/types'
import clsx from 'clsx'
import { graphql, Link as GatsbyLink } from 'gatsby'
import React from 'react'

const ContentfulStaticPageLink: Utils.EntryFC<
  Queries.ContentfulStaticPageLinkFragment
> = ({ content: { slug }, children, fieldInspectorProps }) => {
  const trackNavigationLink = useTrackNavigationLink()

  return (
    <GatsbyLink
      {...fieldInspectorProps({
        fieldId: 'slug',
      })}
      data-type={ENHANCED_COMPONENT_TYPE.HYPERLINK}
      to={slug}
      className={clsx(
        '!text-theme-info-main',
        'hover:text-theme-selected-accent3 hover:underline',
        'group-[.is-blue]/section-template:!text-text-inverse',
        'group-[.is-blue]/component:!text-text-inverse',
        'group-[.is-blue]/section-template:hover:!text-theme-info-accent1',
        'group-[.is-blue]/component:hover:!text-theme-info-accent1'
      )}
      onClick={trackNavigationLink}
    >
      {children}
    </GatsbyLink>
  )
}

export const query = graphql`
  fragment ContentfulStaticPageLink on ContentfulStaticPage {
    ...ContentfulEntry
    slug
  }
`

export default withDisplayName(
  ContentfulStaticPageLink,
  'ContentfulStaticPageLink'
)
